import { computed } from "vue";
import { generateUUID } from "@/src/shared/utils/uuid";
import type { ComputedRef } from "vue";

const DEFAULT_FORM_FIELD_ID_BASE = "ds-field";

const toSafeIdBase = (value?: string | null): string => {
  const normalized = (value || DEFAULT_FORM_FIELD_ID_BASE)
    .trim()
    .replace(/[^A-Za-z0-9_-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  const safeBase = normalized || DEFAULT_FORM_FIELD_ID_BASE;

  return /^[A-Za-z_]/.test(safeBase) ? safeBase : `${DEFAULT_FORM_FIELD_ID_BASE}-${safeBase}`;
};

interface UseDSFormFieldIdArgs {
  props: { id?: string | null; name?: string | null };
}

interface UseDSFormFieldIdReturn {
  id: ComputedRef<string>;
}

export const useDSFormFieldId = ({ props }: UseDSFormFieldIdArgs): UseDSFormFieldIdReturn => {
  const generatedIdSuffix = generateUUID();
  const id = computed(() => props.id || `${toSafeIdBase(props.name)}-${generatedIdSuffix}`);

  return { id };
};
